'use client';

import { Box, Link, Stack, Typography, useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import { useRouter } from 'next/navigation';
import { useSnackbar } from 'notistack';
import Iconify from '../iconify';
import { paths } from '@/app/utilities/consts';
import { RouterLink } from '../router-link/router-link';
import { useBoolean } from '../hooks/use-boolean';
import TransferActivation from '../transferActivationDlg';

export const DeviceManageButtons = ({ device }) => {
  const theme = useTheme();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();
  const transferDlg = useBoolean();

  const handleLogoutClick = async () => {
    try {
      localStorage.removeItem('token');

      enqueueSnackbar('Log out successful', { variant: 'success' });

      router.push('/login');
    } catch (error) {
      router.push('/login');
    }
  };

  return (
    <Stack flexGrow={0} gap={1} minWidth={250}>
      <Link component={RouterLink} href={paths.managePlaylist}>
        <Box
          variant="contained"
          color="success"
          sx={{
            width: '100%',
            bgcolor: theme.palette.primary.dark,
            color: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            px: 3,
            py: 1,
            borderRadius: 1.5,
          }}
        >
          <Iconify icon="icon-park-outline:category-management" />
          <Typography variant="subtitle1">Playlist Management</Typography>
        </Box>
      </Link>
      <Link component={RouterLink} href={paths.activate}>
        <Box
          variant="contained"
          color="success"
          href={paths.activate}
          sx={{
            width: '100%',
            bgcolor: theme.palette.primary.dark,
            color: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            px: 3,
            py: 1,
            borderRadius: 1.5,
          }}
        >
          <Iconify icon="eos-icons:activate-subscriptions" />
          <Typography variant="subtitle1">Activate Device</Typography>
        </Box>
      </Link>

      {device.is_paid && (
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            transferDlg.onTrue();
          }}
          startIcon={<Iconify icon="ant-design:logout-outlined" />}
          sx={{
            width: '100%',
            bgcolor: theme.palette.primary.dark,
            color: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            px: 3,
            py: 1,
            borderRadius: 1.5,
          }}
        >
          <Typography variant="subtitle1">Transfer Activation</Typography>
        </Button>
      )}

      <Button
        variant="contained"
        color="success"
        onClick={handleLogoutClick}
        startIcon={<Iconify icon="ant-design:logout-outlined" />}
        sx={{
          width: '100%',
          bgcolor: theme.palette.primary.darker,
          color: theme.palette.common.white,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1.5,
          mt: 2,
        }}
      >
        Logout
      </Button>

      <TransferActivation
        dialog={transferDlg}
        macAddress={device.mac_address}
        transferCount={device.transferCount || 0}
      />
    </Stack>
  );
};
